import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input, model} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DynamicComponentBase} from '../../service/ng-dynamic-components.service';

@Component({
    selector: 'app-tooltip-change-conflict',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        DatePipe
    ],
    templateUrl: './tooltip-change-conflict.component.html',
    styleUrl: './tooltip-change-conflict.component.scss'
})
export class TooltipChangeConflictComponent extends DynamicComponentBase {

    changedBy = input<string>('');
    changedAt = input<Date>(new Date(0));
    changeMessage = input<string | undefined>();
    isConflict = model<boolean>(false);

    constructor() {
        super();
    }
}
